<template>
    <div class="footer">
        <div class="contact">
            <div class="contact-us">联系我们</div>
            <div class="contact-way">
                <div class="iphone">
                    <img src="@/assets/images/newfooter/iphone.png" alt="二维码" />
                    <p>95338</p>
                </div>
                <ul class="contact-icon">
                    <li :class="{ weixin: true, active: isWeixinActive }" @click="toggleQrCode">
                        <div v-show="isWeixinActive" class="qr-code-popup">
                            <img src="@/assets/images/footer/erweima.jpg" alt="二维码" />
                            <p>将二维码截图保存至相册，打开微信识别相册中的二维码关注</p>
                        </div>
                    </li>
                    <a class="weibo" href="http://weibo.com/sfsuyun?is_hot=1" target="_blank"></a>
                    <li class="service" @click="onlineConsult"></li>
                </ul>
            </div>
            <div class="menus menus-short">
                <div v-for="(item, index) in menusFront4" :key="item.title" class="menus-item">
                    <a :href="item.link" :target="item.target">{{ item.title }}</a>
                    <span v-show="index !== menusFront4.length - 1">|</span>
                </div>
            </div>
            <div class="menus">
                <div v-for="(item, index) in menusLeave" :key="item.title" class="menus-item">
                    <a :href="item.link" :target="item.target">{{ item.title }}</a>
                    <span v-show="index !== menusLeave.length - 1">|</span>
                </div>
            </div>
        </div>
        <div class="copyright">
            <div class="term">
                <a href="/mobile/cn/sc/prd/use" target="_self">使用条款</a> ｜
                <a href="https://ucmp.sf-express.com/v2/we/cxmodules/privacy-policy/home" target="_blank">隐私政策</a> ｜
                <a href="/mobile/cn/sc/prd/service" target="_self">用户协议</a>
            </div>
            <div class="des">© 2017顺丰速运版权所有 粤ICP备08034243号</div>
            <a class="esp" target="_blank" href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030502003091">
                <img src="@/assets/images/newfooter/security_site_3.png" alt="备案" />
                <span>粤公网安备 44030502003091号</span>
            </a>
        </div>
    </div>
</template>

<script>
import ajax from '../../api/ajax'
import getOnlineService from '@/mixins/onlineService/index'
export default {
    data() {
        return {
            menus: [],
            isWeixinActive: false
        }
    },
    computed: {
        menusFront4() {
            return this.menus.slice(0, 4)
        },
        menusLeave() {
            return this.menus.slice(4)
        }
    },
    created() {
        ajax.getHomeMenus().then(res => {
            if (res && res.footerMenu) {
                this.menus = res.footerMenu
            }
        })
    },
    methods: {
        toggleQrCode() {
            this.isWeixinActive = !this.isWeixinActive
        },
        async onlineConsult() {
            const url = await getOnlineService()
            window.open(url, '_blank')
        }
    }
}
</script>
<style lang="scss" scoped>
.footer {
    width: 100%;
    background: #000;
    font-size: 24px;
    color: #fff;
    max-width: 750px;
    min-width: 300px;
    z-index: 100;
    padding: 0.48rem 0.24rem 0.64rem 0.24rem;
    .contact {
        font-size: 35px;
        color: #b1b1b1;
        position: relative;
        padding: 0 30px;
        padding-bottom: 16px;
        justify-content: space-between;
        align-items: center;
        .contact-us {
            color: #fff;
            font-size: 36px;
            font-style: normal;
            text-align: center;
            margin-bottom: 0.24rem;
        }
        .contact-way {
            display: flex;
            justify-content: space-between;
            width: 560px;
            margin: 0 auto;
            .iphone {
                display: flex;
                align-items: center;
                img {
                    width: 56px;
                    height: 56px;
                }
                p {
                    font-size: 48px;
                    font-weight: 500;
                    color: #fff;
                    margin-left: 16px;
                }
            }
        }
        .contact-icon {
            display: flex;
            align-items: center;
            flex: 1;
            justify-content: space-between;
            margin-left: 80px;
            a,
            li {
                display: block;
                font-size: 14px;
                width: 56px;
                height: 56px;
                background-position: center center;
                background-repeat: no-repeat;
                background-size: 56px 56px;
            }
            .weibo {
                width: 56px;
                height: 56px;
                background-image: url('~@/assets/images/newfooter/weibo.png');
            }
            .weixin {
                position: relative;
                width: 56px;
                height: 56px;
                background-image: url('~@/assets/images/newfooter/wechat.png');
                &.active {
                    background-image: url('~@/assets/images/footer/weixin_h.png');
                }
            }
            .service {
                width: 56px;
                height: 56px;
                background-image: url('~@/assets/images/newfooter/service.png');
            }
            .qr-code-popup {
                width: 300px;
                height: 450px;
                position: absolute;
                top: -455px;
                right: -122px;
                background: url('~@/assets/images/newfooter/qr-code-popup.png') center center no-repeat;
                background-size: 3rem 4.5rem;
                border-radius: 16px;
                img {
                    display: block;
                    padding: 20px;
                    width: 100%;
                }
                p {
                    line-height: 36px;
                    font-size: 28px;
                    color: #000;
                    padding: 0 20px;
                }
            }
        }
        .menus {
            display: flex;
            width: 650px;
            flex-wrap: wrap;
            justify-content: center;
            align-items: center;
            margin: 0 auto;
            margin-top: 6px;
            &.menus-short {
                width: 600px;
            }
            .menus-item {
                white-space: nowrap;
                a {
                    color: RGBA(255, 255, 255, 0.6);
                    font-size: 24px;
                }
                span {
                    color: RGBA(255, 255, 255, 0.6);
                    font-size: 26px;
                    margin: 0 20px 0 10px;
                }
            }
        }
    }
    .copyright {
        border-top: 1px solid rgba(255, 255, 255, 0.15);
        font-size: 20px;
        color: RGBA(255, 255, 255, 0.6);
        text-align: center;
        padding-top: 24px;
        .term {
            a {
                color: RGBA(255, 255, 255, 0.6);
            }
        }
        .des {
            padding-top: 24px;
        }
        .esp {
            display: flex;
            justify-content: center;
            align-items: center;
            padding-top: 12px;
            span {
                color: RGBA(255, 255, 255, 0.6);
                margin-left: 10px;
            }
            img {
                width: 20px;
                height: 20px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/index.vue